<template>
  <div class="publicItems">
    <!-- 查询区 -->
    <div class="selectionArea">
      <div class="item">
        <span class="title">时间范围</span>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 300px;"
          @change="handleDateChange"
        />
      </div>

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>

      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
    </div>

    <!-- 表格 -->
    <el-table
      v-loading="loading"
      :data="tableDataarr"
      border
      style="width: 100%; margin-top: 20px;"
      @sort-change="handleSortChange"
    >
      <el-table-column prop="account_name" label="账户名称" align="center" />
      <el-table-column prop="account_id" label="账户ID" align="center" />
      <el-table-column prop="pitcher_name" label="投手" align="center" />
      <el-table-column prop="short_name" label="投放短剧" align="center" />

      <el-table-column
        prop="income_0d_roi"
        label="实时ROI"
        align="center"
        sortable="custom"
      />

      <el-table-column
        prop="roi_30_min"
        label="30分钟ROI"
        align="center"
        sortable="custom"
      />

      <el-table-column
        prop="roi_1_hour"
        label="1小时ROI"
        align="center"
        sortable="custom"
      />

      <el-table-column
        prop="roi_2_hour"
        label="2小时ROI"
        align="center"
        sortable="custom"
      />

      <el-table-column
        prop="cost"
        label="实时消耗"
        align="center"
        sortable="custom"
      />

      <el-table-column
        prop="income_0d"
        label="实时充值"
        align="center"
        sortable="custom"
      />

      <el-table-column
        prop="profit_0d"
        label="实时利润"
        align="center"
        sortable="custom"
      />

      <el-table-column label="关闭项目" align="center" width="120">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="stopre(scope.row)">
            关闭项目
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="openDrawer(scope.row)">
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 抽屉 -->
    <promotion-drawer
      :visible.sync="drawerVisible"
      :account-id="currentAccountId"
    />

    <!-- 停用弹窗 -->
    <stop-promotion-dialog
      :visible.sync="stopDialogVisible"
      :account-id="stopAccountId"
      @refresh="handleRefresh"
    />

    <!-- 分页 -->
    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { pitcherAccountList } from '@/api/notify.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import PromotionDrawer from './components/promotionDrawer.vue'
import StopPromotionDialog from './components/stopPromotionDialog.vue'

export default {
  components: {
    PaginationRight,
    PromotionDrawer,
    StopPromotionDialog
  },
  data() {
    return {
      loading: false,

      tableData: {},
      tableDataarr: [],

      dateRange: null,

      // 查询参数
      parameter: {
        page: 1,
        page_size: 10,
        start_time: null,
        end_time: null
      },

      // 唯一排序参数（关键）
      order_by: null,

      drawerVisible: false,
      currentAccountId: null,

      stopDialogVisible: false,
      stopAccountId: null
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    /* 获取列表 */
    async getDataList() {
      this.loading = true
      try {
        const res = await pitcherAccountList({
          ...this.parameter,
          order_by: this.order_by
        })
        this.tableData = res.data || {}
        this.tableDataarr = res.data?.list || []
      } catch (e) {
        this.tableData = {}
        this.tableDataarr = []
      }
      this.loading = false
    },

    /* 排序（核心） */
    handleSortChange({ prop, order }) {
      if (!order) {
        this.order_by = null
      } else {
        this.order_by = {
          field: prop,
          order: order === 'ascending' ? 'asc' : 'desc'
        }
      }
      this.parameter.page = 1
      this.getDataList()
    },

    /* 日期变化 */
    handleDateChange(val) {
      if (val && val.length === 2) {
        this.parameter.start_time = val[0]
        this.parameter.end_time = val[1]
      } else {
        this.parameter.start_time = null
        this.parameter.end_time = null
      }
    },

    /* 搜索 */
    search() {
      this.parameter.page = 1
      this.getDataList()
    },

    /* 重置 */
    reset() {
      this.dateRange = null
      this.order_by = null
      this.parameter = {
        page: 1,
        page_size: 10,
        start_time: null,
        end_time: null
      }
      this.getDataList()
    },

    /* 分页 */
    fetchPageSize(size) {
      this.parameter.page_size = size
      this.parameter.page = 1
      this.getDataList()
    },

    fetchCurrentPage(page) {
      this.parameter.page = page
      this.getDataList()
    },

    /* 抽屉 */
    openDrawer(row) {
      this.currentAccountId = row.account_id
      this.drawerVisible = true
    },

    /* 停用 */
    stopre(row) {
      this.stopAccountId = row.account_id
      this.stopDialogVisible = true
    },

    handleRefresh() {
      this.getDataList()
    }
  }
}
</script>

<style scoped>
.publicItems {
  padding: 20px;
}

.selectionArea {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.title {
  margin-right: 10px;
  white-space: nowrap;
}
</style>
